package one.healthium.domain.paywall.models


import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames
import one.healthium.domain.common.TextStyle

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("terms_privacy")
data class PaywallPrivacyView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PaywallPrivacyConfig,
) : PaywallScreenView

@Serializable
data class PaywallPrivacyConfig(
    @SerialName("restore_title") val restoreTitle: String? = null,
    @SerialName("text_label") val textLabel: TextStyle? = null,
)